import { Form } from "@redriver/cinnamon-mui";
import { clientStatusLookup } from "modules/lookups";

const ClientStatusDropdown = (props) => (
  <Form.Dropdown {...props} lookup={clientStatusLookup} />
);

export default ClientStatusDropdown;
